import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './CustomTopbarButton.module.css';

const CustomTopbarButton = ({ 
  onClick, 
  label, 
  labelId, 
  className, 
  disabled = false,
  icon = null 
}) => {
  const handleClick = (e) => {
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <button
      className={`${css.customTopbarButton} ${className || ''}`}
      onClick={handleClick}
      disabled={disabled}
      type="button"
    >
      {icon && <span className={css.icon}>{icon}</span>}
      <span className={css.label}>
        {labelId ? (
          <FormattedMessage id={labelId} />
        ) : (
          label
        )}
      </span>
    </button>
  );
};

export default CustomTopbarButton; 